import '@/scss/page-templates/faqs.scss';

import Accordion from "accordion-js";
import "accordion-js/dist/accordion.min.css";

console.log('faqs.ts');

document.addEventListener('DOMContentLoaded', () => {
  // let accordionT = new Accordion('.faq__categories');
  let accordionEls = Array.from(document.querySelectorAll(".accordion-container"));
  let accordions:any[] = [];
  let accordionItemsLength:any[] = [];
  let prevAccordionIndex:number|null = null;
  let prevAccordionItemIndex:number|null = null;

  for( let i=0; i<accordionEls.length; i++ ) {
    let itemsCount:number = accordionEls[i].querySelectorAll('.ac').length;
    accordionItemsLength.push(itemsCount);

    let accordion = new Accordion(accordionEls[i], {
      beforeOpen: (element:any) => {
        if( prevAccordionIndex !== null && prevAccordionItemIndex !== null ) {
          accordions[prevAccordionIndex].close(prevAccordionItemIndex);
        }

        // console.log('opening accordion index '+i);
        // console.log(element);
        let index:number|null = null; 
        try {
          index = parseInt(element.id.split('ac-')[1]);
        } catch(e) {

        }

        if( index !== null ) {
          for( let j=0; j<accordionItemsLength.length; j++ ) {
            if( j < i ) {
              index -= accordionItemsLength[j];
            }
            
          }

          console.log('index:', index);

          prevAccordionIndex = i;
          prevAccordionItemIndex = index;

          // for( let j=0; j<accordions.length; j++ ) {
          //   if( j !== i ) {
          //     // accordions[j].closeAll();
          //   }
          // }
        }
      }
    })

    accordions.push(accordion);
  }
  // let accordions = new Accordion(accordionEls, {
  //   beforeOpen: (element:any) => {
  //     // console.log(element);
  //     // for( let i=0; i<accordions.length; i++ ) {
  //     //   accordions[i].close();
  //     // }
  //   }
  // });

  // console.log(accordions);
  window.accordions = accordions;
})